import React, { useState, useEffect, Fragment } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import { ChangePasswordModal } from './ChangePasswordModal';

export const LoginMenu = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userName, setUserName] = useState<string | null | undefined>(null);
    const [hasAdminUser, setHasAdminUser] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [ready, setReady] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    useEffect(() => {
        const subscription = authService.subscribe(() => populateState());
        populateState();
        checkAdminUserExists();

        return () => {
            if (subscription) {
                authService.unsubscribe(subscription);
            }
        };
    }, []);

    const populateState = async () => {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()]);
        setIsAuthenticated(isAuthenticated);
        setUserName(user?.profile?.name);
        setReady(true);
    };

    const checkAdminUserExists = async () => {
        try {
            const response = await fetch('/api/Account/HasAdmins');
            if (response.ok) {
                const data = await response.json();
                setHasAdminUser(data.hasAdmins);
            }
        } catch (error) {
            // Error handling - silent fail
        }
    };

    const toggleChangePasswordModal = () => {
        setShowChangePasswordModal(prev => !prev);
        handleMenuClose();
    };

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const renderAuthenticatedView = () => {
        const logoutPath = `${ApplicationPaths.LogOut}`;
        const logoutState = { local: true };

        return (
            <Fragment>
                <Button color="inherit" onClick={handleMenuOpen}>
                    {userName}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={toggleChangePasswordModal}>Сменить пароль</MenuItem>
                    <MenuItem component={Link} to={logoutPath} state={logoutState} onClick={handleMenuClose}>
                        Выход
                    </MenuItem>
                </Menu>
                <ChangePasswordModal isOpen={showChangePasswordModal} toggle={toggleChangePasswordModal} />
            </Fragment>
        );
    };

    const renderAnonymousView = () => {
        const registerPath = `${ApplicationPaths.Register}`;
        const loginPath = `${ApplicationPaths.Login}`;

        return (
            <Fragment>
                {!hasAdminUser ? (
                    <Button color="inherit" component={Link} to={registerPath}>
                        Регистрация
                    </Button>
                ) : (
                    <Button color="inherit" component={Link} to={loginPath}>
                        Вход
                    </Button>
                )}
            </Fragment>
        );
    };

    if (!ready) {
        return null;
    }

    return isAuthenticated ? renderAuthenticatedView() : renderAnonymousView();
};
